export const GET_DECEASED_USERS = 'get_deceased_users';
export const SET_HSMV_REQUEST = 'set_hsmv_request';
export const RESET_DECEASED_USERS = 'reset_deceased_user';
export const SET_FILTERS = 'set_filters';
export const GET_DUPLICATE_CARDHOLDERS = 'get_duplicate_cardholders';
export const RESET_DUPLICATE_USERS = 'reset_duplicate_user';
export const SET_DUPLICATE_FILTERS = 'set_duplicate_filters';
